import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from "@angular/router";
import {IResourcePath} from "../../models/common";
import {getResourceImagePath} from "../../models/view";
import {EDSngMediaService} from "../edsng-media.service";
import {setWindowTitle} from "../../commonUtil";

import {ActionsService} from "../../Redux/Actions/actions.service";
import {TranslateService} from "@ngx-translate/core";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {ConfirmDownloadDlgComponent} from "./confirm-download-dlg/confirm-download-dlg.component";
import {Overlay} from "@angular/cdk/overlay";

@Component({
  selector: 'edsng-hackathon-page',
  templateUrl: './hackathon-page.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./hackathon-page.component.css', './hackathon-page-mobile.component.css', './hackathon-page-tablet.component.css']
})
export class HackathonPageComponent implements OnInit  {
  resolution = "md";
  edsImages: any;

  constructor(private actSvc: ActionsService, private router: Router, private media: EDSngMediaService, public translate: TranslateService,  private dialog: MatDialog, public overlay: Overlay)   {}

  ngOnInit() {
    this.media.sizeAlias.subscribe(x => {
      this.resolution = x;
    });
    setWindowTitle(null, this.translate);
  }

  getResourceImage(a: string, b: IResourcePath): string {
    return getResourceImagePath(a, b);
  }

  openDialog(filename: string): void {
    const config = new MatDialogConfig();
    config.hasBackdrop = false;
    config.width = "400";
    config.height = "50%";
    config.data = {file: filename};
    const dialogRef = this.dialog.open(ConfirmDownloadDlgComponent, config);
  }

  openTool(url: string) {
    window.open(url, '_blank');
  }


}
